<template>
  <div class="SearchPage">
    <div class="Container">
      <div
        :class="[{'is-active': filterOpen}, 'Filters-mobile']"
      >
        <a
          href="#"
          class="Button Button--long"
          @click.prevent="toggleFilters()"
        >Filter</a>
        <div
          v-if="filterOpen"
          class="Filters-overlay"
          @click.prevent="toggleFilters()"
        />
      </div>
      <div class="Row Row--search">
        <div class="Col Col-sm-12 Col-md-3 SearchFilters">
          <div class="card is-rounded has-border Block SearchLinks">
            <search-type />
          </div>
          <div
            :class="[{'is-active': filterOpen}, 'Filters-container']"
          >
            <div class="SearchFilters-lists">
              <search-filters
                :available-filters="config.availableFilters"
              />
              <hr class="medium">
              <div class="SearchFilter">
                <search-sort
                  data-cy-id="search-sort"
                  :sort-fields="config.sortFields"
                />
              </div>
            </div>

            <div :class="[{'is-active': filterOpen}, 'MobileFilterApplyFilter']">
              <a
                :class="['Button Button--long Button--primary', { 'loading' : isSearchResultsLoading }]"
                href="#"
                @click.prevent="toggleFilters()"
              >View {{ resultCount }} Results </a>
            </div>
          </div>
        </div>
        <div class="Col Col-md-9 SearchResults">
          <!-- <div class="NavNotice&#45;&#45;info SearchSuggestions-header">We are supporting National Apprenticeship Week! Find out more <a target="_blank" href="/advice/national-apprenticeship-week-2021">HERE</a></div> -->
          <search-input />

          <div class="Card is-rounded has-border Block u-noPadding">
            <search-result-total />

            <search-quick-filters />

            <search-alternative-locations />

            <search-results />

            <search-pagination />

            <search-loading-state />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
